import './App.css';
import React from 'react';
import CheckOut from './components/CheckOut/CheckOut';
import {
  BrowserRouter,
  Route,
  Routes,
  } from 'react-router-dom'; 
import CheckoutForm from './components/Internal/CheckoutForm';

function App() {


	return (
		<div className='App'>
        <CheckOut></CheckOut>
     <div>
     <BrowserRouter basename="/checkout">
      <Routes>
      <Route index element={<CheckoutForm />} />
      </Routes>
    </BrowserRouter>
    </div>
    </div>
         
		
	);
}

export default App;